<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">PV Memo</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create PV Memo</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer">
        <form @submit.prevent="handleSubmit()">
          <div class="crud-form position-relative">

            <div class="form-inner mb-2">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Create PV Memo</h1>
              </div>

              <div class="header-box d-flex justify-content-between align-items-center mb-3">
                <div class="progress-bar" :style="{
                  '--progress-width': progressWidth,
                  '--step-count': totalSteps
                }">
                  <div class="step-icon" v-for="(s, i) in totalSteps" :key="'icon-' + i">
                    <div :class="['step', { active: step === i + 1, completed: step > i + 1 }]">
                      {{ step > i + 1 ? '✓' : i + 1 }}
                    </div>
                  </div>

                  <div class="progress-line" :style="{ '--progress-width': progressWidth }" />

                  <div class="step-label text-wrap" v-for="(s, i) in steps" :key="'label-' + i"
                    :class="{ active: step === i + 1 }">
                    {{ s.label }}
                  </div>
                </div>
              </div>

              <div>

                <div class="form-body">
                  <!-- <h2 class="field-head">A. General Information</h2> -->
                  <div class="row mb-3">
                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">File Title</label></div>
                      <div class="col-md-9 input-right">
                        <input id="fileName" type="text" class="form-control" v-model="form.fileTitle"
                          placeholder="Enter file title" required />
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">File Number</label></div>
                      <div class="col-md-9 input-right">
                        <input id="fileNumber" type="text" class="form-control" v-model="form.fileNumber"
                          placeholder="Enter file number" required />
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Sector</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="sector" @change="onSectorChange" required>
                          <option value="" disabled>- Select Sector -</option>
                          <option v-for="sector in sectors" :key="sector.id" :value="sector.id">{{ sector.code }} ({{
                            sector.name }})</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Originating M.D.A.</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="mda" @change="onMdaChange" required>
                          <option value="" disabled>- Select MDA -</option>
                          <option v-for="mda in mdas" :key="mda.id" :value="mda.id">{{ mda.name }}</option>
                        </select>
                        <input type="hidden" v-model="form.originatingMda">
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Amount Approved (₦)</label></div>
                      <div class="col-md-9 input-right">

                        <input id="amountApproved" type="text" class="form-control"
                          :value="formatCurrency(form.amountApproved)" inputmode="numeric"
                          @input="onAmountApprovedInput" placeholder="0.00" required />
                        <!-- <input id="amountApproved" type="text" class="form-control"
                          :value="formatNumber(form.amountApproved)" inputmode="numeric" pattern="[0-9,]*"
                          @keypress="onlyDigitsAndComma" @input="onAmountApprovedInput" placeholder="" required /> -->
                      </div>
                    </div>

                    <!-- <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Purpose of Request</label></div>
                      <div class="col-md-9 input-right">
                        <div class="col-md-12 input-right">
                          <textarea class="form-control" id="description" v-model="form.purposeOfRequest" placeholder=""
                            rows="3" required></textarea>
                        </div>
                      </div>
                    </div> -->

                    <!-- <input type="hidden" v-model="form.created_by" /> -->

                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div class="d-flex justify-content-center gap-3">

                  <button type="submit" class="btn btn-primary submit-btn" :disabled="loading">

                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>

                    {{ (loading ? 'Submitting...' : 'Submit') }}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useRouter } from 'vue-router'

const router = useRouter();
const mdas = ref([])

const sectors = ref([])

const sector = ref('')
const mda = ref('')

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const loading = ref(false)
const totalSteps = 1
const step = ref(1)

const steps = [
  { label: 'General Information' },
]

const progressWidth = computed(() => {
  const total = steps.length;
  const percentPerStep = 100 / total;
  return (step.value * percentPerStep) + '%';
});

// Reactive form data
const form = reactive({
  originatingMda: '',
  mdaId: '',
  orgCode: '',
  amountApproved: '',
  fileTitle: '',
  fileNumber: '',
  // purposeOfRequest: '',
  ticketId: '',
  isEditableInd: '',
  groupTypeId: '',
  memoRejectedInd: '',
  memoReturnedInd: '',
  grpHeadGrpMemId: '',
  grpHeadGrpMemRemarks: '',
  grpHeadGrpMemRemarksDate: '',
  id: '',
  version: '',
  createdDate: '',
  lastModifiedDate: '',
  createdBy: '',
  lastModifiedBy: '',
  userId: '',
})

const initialForm = JSON.parse(JSON.stringify(form));

function resetAll() {
  sector.value = '';
  mda.value = '';
  mdas.value = [];
  Object.assign(form, JSON.parse(JSON.stringify(initialForm)));
}

// const mda_datas = ref('')

const fetchSectors = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/sector`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    sectors.value = response.data.map(sector => ({
      id: sector.id,
      code: sector.sectorCode,
      name: sector.description,
    }))

  } catch (error) {
    console.error('Failed to fetch sectors:', error)
  }
}

const fetchMDAs = async (sector_id) => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda/all/${sector_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
      orgCode: mda.orgCode,
      groupTypeId: mda.groupTypeId,
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  const memoData = {
    fileTitle: form.fileTitle,
    fileNumber: form.fileNumber,
    mdaId: form.mdaId || mda.value,
    originatingMda: form.originatingMda,
    orgCode: form.orgCode,
    amountApproved: Number(form.amountApproved || 0),
    groupTypeId: form.groupTypeId,
  };

  loading.value = true;

  try {
    const { data } = await axios.post(`${root_api_url}/payment/memo`, memoData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Memo Created Successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    }).then(() => {
      resetAll()
      // Navigate to the newly created PV memo view
      if (data?.id) {
        router.push({ name: 'ViewPVMemo', params: { id: data.id } })
      }
    });

  } catch (error) {
    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to create memo</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });

    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.message || error?.response?.data?.errorMessage || error?.response?.data?.error || 'Failed to create memo'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred. Kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    loading.value = false; // Stop loading
  }
}

onMounted(() => {
  // fetchApprovalAuthority()
  // fetchMDAs()
  fetchSectors()
  document.title = "Create PV Memo"
})

function onSectorChange() {
  // console.log('Sector changed to', sector.value)
  // fetchMdaDetails(mda.value)
  fetchMDAs(sector.value)
}

function onMdaChange() {
  // console.log('MDA changed to', mda.value)
  const selected = mdas.value.find(item => item.id === mda.value)
  form.originatingMda = selected ? selected.name : ''
  form.mdaId = selected ? selected.id : ''
  form.orgCode = selected ? (selected.orgCode || '') : ''
  form.groupTypeId = selected ? (selected.groupTypeId || '') : ''
}

/**
 * Format any number with commas
 */
// function formatNumber(val) {
//   return Number(val || 0).toLocaleString();
// }

// /**
//  * Block keys other than digits, comma, or navigation
//  */
// function onlyDigitsAndComma(e) {
//   const k = e.key;
//   if (
//     (k >= '0' && k <= '9') ||
//     k === ',' || k === '.' ||
//     ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(k)
//   ) return;
//   e.preventDefault();
// }

// /**
//  * Handle the “Amount Approved” input:
//  * - strip non‑digits
//  * - update the numeric model
//  * - re‑format the visible field
//  */
// function onAmountApprovedInput(e) {
//   const digits = e.target.value.replace(/[^\d]/g, '');
//   form.amountApproved = digits === '' ? 0 : Number(digits);
//   e.target.value = formatNumber(form.amountApproved);
// }


function formatCurrency(val) {
  if (val === '' || val === null) return '';
  const num = parseFloat(val).toFixed(2);
  return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Handle Amount Approved input
 */
const MAX_SAFE_RAW = Number.MAX_SAFE_INTEGER.toString(); // "9007199254740991"

function onAmountApprovedInput(e) {
  let raw = e.target.value.replace(/\D/g, '');

  if (raw === '') {
    form.amountApproved = '';
    e.target.value = '';
    return;
  }

  // Prevent adding more digits than safe
  if (raw.length > MAX_SAFE_RAW.length ||
    (raw.length === MAX_SAFE_RAW.length && raw > MAX_SAFE_RAW)) {
    raw = MAX_SAFE_RAW; // trim to safe max
  }

  const num = parseInt(raw, 10) / 100;
  form.amountApproved = Number(num.toFixed(2));
  e.target.value = formatCurrency(form.amountApproved);
}
</script>

<style scoped>
.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
  padding-right: 0;
  margin-right: 1rem;
  margin-bottom: 0.5rem !important;
}

.budget-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  /* forces every .col to match the tallest */
}

.budget-item-wrapper .view-only-input,
.budget-item-wrapper input.view-only-input {
  flex: 1;
  /* inputs (and your Approval‐Authority <div>) all grow equally */
  /* for your Approval Authority div: */
  white-space: pre-wrap;
}

.dashboard-layout .budget-item-wrapper {
  margin-top: 20px;
  padding: 0 40px;
}

.dashboard-layout .content-wrapper {
  border: 1px solid var(--border);
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 1rem;
}

.dashboard-layout .section-border {
  /* padding: 1rem; */
  border-top: 3px solid #667eea !important;
}

.dashboard-layout .step-2 {
  padding: 0 20px;
}

.dashboard-layout .budget-item-wrapper.step-2 .col {
  border-right: 1px solid var(--border);
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); */
}

.dashboard-layout .budget-item-wrapper.step-2 .col.no-border {
  border-right: none !important;
}

.dashboard-layout .budget-item-wrapper.step-3 .fixed-label {
  min-height: 80px;
  justify-content: flex-start;
  width: 350px;
  box-sizing: border-box;
  text-align: left;
  /* all: unset; */
  display: flex;
  margin-bottom: 0;
  flex-shrink: 0;
  margin-left: 1rem;
}

.dashboard-layout .budget-item-wrapper.step-3 .col {
  padding: 0;
}

.dashboard-layout .budget-item-wrapper.step-3 .content-wrapper {
  border: 1px solid var(--border);
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  /* padding: 1rem; */
}

.dashboard-layout .budget-item-wrapper.step-3 .content {
  border-bottom: 2px solid var(--border);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  gap: 1rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.dashboard-layout .budget-item-wrapper.step-3 label {
  font-size: 16px;
  padding: .375rem 0 !important;
  margin-bottom: 0px !important;
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.dashboard-layout .budget-item-wrapper .col-md-3 {
  border: 1px solid #212529;
}

.dashboard-layout .budget-item-wrapper .col-md-3.no-border {
  border: none;
}

.dashboard-layout .budget-item-wrapper .col-md-3.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border {
  border: none;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 4rem;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
}
</style>
